import Window from "../Window";
import ImageUploader from "../ImageUploader";
import { useState } from "react";
import { modalStyles } from "./style.js";
import { getSize } from "../../utils";

const InstallModal = ({
  userId,
  name,
  fileSystem,
  hash,
  handleInstallApp,
  closeInstaller,
  localMode,
}) => {
  const fileNode = fileSystem.getFile(hash);
  const fileSize = fileNode.getSize();
  const fileName = fileNode.getName();
  const [iconUrl, setIconUrl] = useState();
  const [appName, changeAppName] = useState("");
  const [authorName, changeAuthorName] = useState("");
  const [shareApp, setShareApp] = useState(false);
  const highlight = (e) => {
    e.target.style.opacity = 0.5;
  };
  const unhighlight = (e) => {
    e.target.style.opacity = 1;
  };
  return (
    <Window id={hash} name={name} top={0} left={0} onCancel={closeInstaller}>
      <div style={modalStyles.frame}>
        <div style={modalStyles.label}>Source File Information</div>
        <div style={modalStyles.info}>File Name: {fileName}</div>
        <div style={modalStyles.info}>File Size: {getSize(fileSize)}</div>

        <div style={modalStyles.label}>App Information</div>
        <div style={modalStyles.info}>
          App Name:{" "}
          <input
            type="text"
            value={appName}
            onChange={(e) => changeAppName(e.target.value)}
            style={modalStyles.input}
          />
        </div>
        {shareApp && (
          <div style={modalStyles.info}>
            Author Nickname:{" "}
            <input
              type="text"
              value={authorName}
              onChange={(e) => changeAuthorName(e.target.value)}
              style={modalStyles.input}
            />
          </div>
        )}
        <div style={modalStyles.info}>
          App Icon:
          <ImageUploader imageUrl={iconUrl} setImageUrl={setIconUrl} />
        </div>
        {!localMode && (
          <div style={modalStyles.info}>
            <input
              type="checkbox"
              id="share"
              name="share"
              onChange={(e) => {
                setShareApp(e.target.checked);
              }}
            />
            <label htmlFor="share">Share to App Store</label>
          </div>
        )}

        <div
          style={modalStyles.button}
          onMouseOver={highlight}
          onMouseOut={unhighlight}
          onClick={async () => {
            const res = await handleInstallApp({
              userId,
              hash,
              shareApp,
              appName,
              authorName,
              fileSize,
              iconUrl,
            });
            if (res.error) {
              alert(res.errMsg);
            } else {
              closeInstaller();
            }
          }}
        >
          Submit Application
        </div>
      </div>
    </Window>
  );
};

export default InstallModal;
